import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckEmailModule } from './check-email/check-email.module';
import { CheckEmailComponent } from './check-email/components/check-email/check-email.component';
import { EmailVerficationComponent } from './email-verification/components/email-verfication/email-verfication.component';
import { EmailVerificationModule } from './email-verification/email-verification.module';
import { ForgetPasswordModule } from './forget-password/forget-password.module';
import { RegisterModule } from './register/register.module';
import { ResetPasswordModule } from './reset-password/reset-password.module';
import { SignInModule } from './sign-in/sign-in.module';
import { UserModule } from './user/user.module';

const routes: Routes = [
  { path: "register", loadChildren: () => RegisterModule, data: { animation: 'register' } },
  { path: 'forgot-password', loadChildren: () => ForgetPasswordModule },
  { path: 'reset-password/:token', loadChildren: () => ResetPasswordModule },
  { path: 'check-email', loadChildren: () => CheckEmailModule, component: CheckEmailComponent },
  { path: 'login', loadChildren: () => SignInModule, data: { animation: 'login' } },
  { path: 'verify/:token', loadChildren: () => EmailVerificationModule, component: EmailVerficationComponent },
  // { path: 'apple/callback', loadChildren: () => SignInModule, data: { animation: 'login' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UnauthorizedRoutingModule { }
